export const SEARCH_BLUR = 'SEARCH_BLUR';
export const SEARCH_FOCUS = 'SEARCH_FOCUS';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const SEARCH_KEYBOARD_UP = 'SEARCH_KEYBOARD_UP';
export const SEARCH_KEYBOARD_DOWN = 'SEARCH_KEYBOARD_DOWN';
export const SEARCH_KEYBOARD_ENTER = 'SEARCH_KEYBOARD_ENTER';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const USER_SET_DATA = 'USER_SET_DATA';
export const USER_SET_ERROR = 'USER_SET_ERROR';
export const USER_START_LOADING = 'USER_START_LOADING';
export const USER_FINISH_LOADING = 'USER_FINISH_LOADING';

export default {
  SEARCH_BLUR,
  SEARCH_FOCUS,
  UPDATE_SEARCH_TERM,
  SEARCH_KEYBOARD_UP,
  SEARCH_KEYBOARD_DOWN,
  SEARCH_KEYBOARD_ENTER,
  USER_SET_DATA,
  USER_SET_ERROR,
  USER_START_LOADING,
  USER_FINISH_LOADING,
};
